import { baseUrl } from "../../../boot/index";
import axios from "axios";

// Add lead
export const addInvitation = async (formData) => {
    console.log("user form data ---- ", formData);
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.post(`${baseUrl}cleaningappfunctions/user/app/v1/users-invitation-emails`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      console.log("response",response)
      return response;
    } catch (error) {
      throw error
    }
  }